const Select = {
  variants: {
    outline: {
      field: {
        fontSize: '14px',
        bg: 'surface.default',
        borderColor: 'border.strong',
        borderRadius: 'md',
        minH: '44px',
        _hover: { borderColor: 'accent.default' },
        _focusVisible: {
          borderColor: 'accent.default',
          boxShadow: 'outline',
        },
      },
    },
  },
  defaultProps: { variant: 'outline' },
};

export default Select;
